/**
 * API class to help us make API requests easier
 */
let api = function() {
    /**
     * The base URL of the API
     *
     * @type string
     */
    let _baseUrl = '';

    /**
     * Perform the request
     *
     * @param {string} method
     * @param {string} url
     * @param {object} options
     */
    function request(method, url, options) {
        if (_baseUrl === '') {
            _baseUrl = $('meta[name="base"]').prop('content') + "/api/v" + $('meta[name="api"]').prop('content');
        }

        // Settings array based on defaults + options
        let settings = $.extend({}, {
            data: {},
            timeout: 2000,
            success: function() {},
            error: function (response) {
                window.api.errorsFromAjax(response, options.hasOwnProperty('errorContainer') ? options.errorContainer : undefined);
            },
            complete: function() {}
        }, options);

        // Perform the request
        axios.request({
            url: _baseUrl + url,
            method: method,
            params: (method === 'GET' ? settings.data : {}),
            data: (method === 'PUT' || method === 'POST' || method === 'PATCH' ? settings.data : {}),
            timeout: settings.timeout,
        }).then(function (response) {
            settings.success(response.data);
            settings.complete(response.data);
        }).catch(function (data) {
            if (data.hasOwnProperty('response') && data.response !== undefined && data.response.hasOwnProperty('data')) {
                settings.error(data.response.data);
                settings.complete(data.response.data);
            } else {
                console.debug(data);
            }
        });
    }

    /**
     * Generate errors from an ajax API error response
     *
     * @param {object} response
     * @param {object} selector
     */
    this.errorsFromAjax = function(response, selector) {
        if (response.hasOwnProperty('debug')) {
            console.debug(response);
        }
        if (response.hasOwnProperty('error')) {
            // Clear out the selector if it's not undefined
            if (selector !== undefined) {
                $(selector).html('');
            }

            // Print out error messages
            if (response.hasOwnProperty('errors')) {
                for (let err in response.errors) {
                    PageErrors.Error(response.errors[err], selector);
                }
            } else {
                PageErrors.Error(response.error, selector);
            }
        }
    };

    /**
     * Perform a GET request
     *
     * @param {string} url
     * @param {object} options
     */
    this.get = function(url, options) {
        request('GET', url, options);
    };

    /**
     * Perform a POST request
     *
     * @param {string} url
     * @param {object} options
     */
    this.post = function(url, options) {
        request('POST', url, options);
    };

    /**
     * Perform a PUT request
     *
     * @param {string} url
     * @param {object} options
     */
    this.put = function(url, options) {
        request('PUT', url, options);
    };

    /**
     * Perform a PATCH request
     *
     * @param {string} url
     * @param {object} options
     */
    this.patch = function(url, options) {
        request('PATCH', url, options);
    };

    /**
     * Perform a Delete request
     *
     * @param {string} url
     * @param {object} options
     */
    this.delete = function(url, options) {
        request('DELETE', url, options);
    };
};

// Export the API module
module.exports = new api();
